<template>
	<VerticalLayout>
		<Row :gutter="[16, 8]">
			<Col :span="24">
				<div class="scrollable-x">
					<Table :columns="columns" :data-source="statsTableDataDisplay" :pagination="false" :loading="isLoading" />
				</div>
			</Col>
		</Row>
		<CasterStatsDynamicsChartPage class="pd-vertical" />
	</VerticalLayout>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { Row, Col, Table } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import VerticalLayout from '@/components/common/VerticalLayout';
import CasterStatsDynamicsChartPage from '@/components/stats/CasterStatsDynamicsChartPage';

import { datetimeToString } from '@/components/common/dateUtils';

const LABELS = [
	'vrs', 'near', 'net',
];

export default {
	components: {
		Row, Col, Table,
		VerticalLayout, CasterStatsDynamicsChartPage,
	},
	setup() {
		const { t } = useI18n();
		const { apiData, isLoading, doRequest } = Api.useCasterStatsMainGet();
		const getLabelStr = label => {
			return LABELS.includes(label) ? t('stats.network-metrics.labels.' + label) : label;
		};
		const statsTableDataDisplay = computed(() => {
			return apiData.value.rows.map(item => ({
				...item,
				labelStr: getLabelStr(item.label),
				lastUpdate: item.lastUpdate ? datetimeToString(item.lastUpdate) : t('stats.network-metrics.noData'),
			}));
		});
		onMounted(() => {
			// # TODO: subnets phase 8. После того, как согласуем формат статистики кастера
			// # TODO: subnets phase 8. Добавить подсеть в запрос, если делаем отдельные запросы для каждой подсети.
			// # TODO: subnets phase 8. Или группируем по подсетям и выдаем клиенту по всем сразу с разбивкой. Это надо уточнить в конце
			doRequest();
		});

		return {
			columns: Consts.mainStatsTableColumnsComp,
			statsTableDataDisplay,
			isLoading,
		};
	}
}
</script>
